export const locale = {
  addChart: 'Add chart',
  addNewChart: 'Add new chart',
  selectTypeChart: 'Select type chart',
  searchSymbol: 'Search symbols to add in chart',
  date: 'Select date',
  time: 'Select time',
  firstPoint: 'Point 1',
  secondPoint: 'Point 2',
  showVWap: 'Show VWAP',
  vWapHint: 'VWAP (Volume-Weighted Average Price) is calculated by adding up the dollars traded for every transaction (price multiplied by number of shares traded) and then dividing by the total shares traded for the day.',
  vWapHintNoData: 'There is no VWAP for this instrument'
};
